import { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { Box, Button, InputAdornment, OutlinedInput, Paper, Stack, Typography } from '@mui/material'
import ToastMsg from '../../../../../../Components/ToastMsg/ToastMsg'
import { CommonPatientCard, CommonPatientDetails, ConsultantPatientCard } from '../../../../../../Components/Common Components/CommonComponents'
import { getCachevalue, localGetItem } from '../../../../../../Utility/Services/CacheProviderService'
import Loader from '../../../../../../Components/Loader'
import { Colors } from '../../../../../../Styles/Colors'
import CommonValidation from '../../../../../../Components/CommonFunctions/CommonValidation'
import RestAPIService from '../../../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../../../Utility/API/Serviceurls'
import { AmountFormat, CheckAccessFunc } from '../../../../../../Components/CommonFunctions/CommonFunctions'
import { CurrencySymbol } from '../../../../../../Utility/Constants'

class ClaimDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ipPatientData: {},
            opPatientData:{},
            TotalBillAmt: 0,
            PendingAmt: 0,
            ApprovedAmt: "",
            isDisabled: false,
            CreditDetails: [],
            receivedAmt: 0,
            DisallowanceAmt: "",
            TDSAmount: "",
            TotalClaimAmt: "",
            claimAmounts: '',
            Patientpaid: 0.00,
            InsuReceivedAmt: 0.00,
            InsuClaimAmt: 0.00,
        }
    }

    componentDidMount() {
        let ipPatientData = getCachevalue("IppatientData")
        let opPatientData = getCachevalue("patientData")
        let patientData = this.props?.FromOP ? JSON.parse(opPatientData) : JSON.parse(ipPatientData)
        this.setState({
            ipPatientData: patientData,
            opPatientData: patientData
        }, () => { this.getPatientData() })
    }

    getPatientData = () => {
        try {
            let AdmissionId = this.state?.ipPatientData?.id ? this.state?.ipPatientData?.id : ""
            let AppointmentId = this.state?.opPatientData?.appointment_id ? this.state?.opPatientData?.appointment_id : ""
            let APIUrl = ''
            if (this.props?.FromOP) {
                APIUrl = Serviceurls.GET_OP_CREDIT_DETAILS + '?appointment_id=' + AppointmentId
            } else {
                APIUrl = (localGetItem('isNewBilling') === "false" ? Serviceurls.IP_PATIENT_DETAILS : Serviceurls.IP_PATIENT_DETAILS_NEW) + '?admission_id=' + AdmissionId
            }
            RestAPIService.getAll(APIUrl)
                .then((response) => {
                    if (response.data.status === "success") {
                        if (this.props?.FromOP) {
                            this.setState({
                                TotalBillAmt: response?.data?.data?.total_bill_amount || 0,
                                TotalClaimAmt: response?.data?.data?.claimed_amount || 0,
                                isDisabled: true,
                                PendingAmt: +response?.data?.data?.total_balance_amount || 0 ,
                                CreditDetails: response?.data?.data,
                                receivedAmt: response?.data?.data?.total_paid_amount || 0,
                                ApprovedAmt: response?.data?.data?.approved_amount || 0,
                                DisallowanceAmt: response?.data?.data?.disallowance_amount || 0,
                                TDSAmount: response?.data?.data?.tds_amount || 0,
                                claimAmounts: response?.data?.data?.claimed_amount || 0,
                                Patientpaid: response?.data?.data?.patient_paid || 0.00,
                                InsuReceivedAmt: response?.data?.data?.total_paid_amount || 0.00,
                                InsuClaimAmt: response?.data?.data?.claimed_amount || 0.00
                            })
                        }
                        else {
                            this.setState({
                                TotalBillAmt: response?.data?.data[0]?.service_amount,
                                TotalClaimAmt: response?.data?.data[0]?.claimed_amount ? response?.data?.data[0]?.claimed_amount : "",
                                isDisabled: response?.data?.data[0]?.claimed_amount > 0 || !response?.data?.data[0]?.is_final_bill_generated ? true : false,
                                PendingAmt: response?.data?.data[0]?.is_final_bill_generated ? ((+response?.data?.data[0]?.service_amount - (response?.data?.data[0]?.paid_amount)) - (response?.data?.data[0]?.claimed_amount ? +response?.data?.data[0]?.claimed_amount : 0)) : 0,
                                CreditDetails: response?.data?.data[0],
                                receivedAmt: response?.data?.data[0]?.paid_amount,
                                ApprovedAmt: response?.data?.data[0]?.approved_amount,
                                DisallowanceAmt: response?.data?.data[0]?.disallowance_amount,
                                TDSAmount: response?.data?.data[0]?.tds_amount,
                                claimAmounts: response?.data?.data[0]?.claim_amount,
                                Patientpaid: response?.data?.data[0]?.patient_paid || 0.00,
                                InsuReceivedAmt: response?.data?.data[0]?.insurance_received_amount || 0.00,
                                InsuClaimAmt: response?.data?.data[0]?.insurance_claim_amount || 0.00
                            })
                        }

                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    LoaderFunction = (key = false) => {
        this.setState({
            isLoader: key
        })
    }

    handleClear = () => {
        this.setState({
            ApprovedAmt: "",
            DisallowanceAmt: "",
            TDSAmount: "",
            TotalClaimAmt: ""
        })
    }

    handleSave = () => {
        let Company_Name = this.state?.CreditDetails?.credit_type === "Insurance credit" ? this.state?.CreditDetails?.insurance_name : this.state?.CreditDetails?.credit_type === "Corporate credit" ? this.state?.CreditDetails?.employer_name : null;
        let ID_No = this.state?.CreditDetails?.credit_type === "Insurance credit" ? this.state?.CreditDetails?.policy_no : this.state?.CreditDetails?.credit_type === "Corporate credit" ? this.state?.CreditDetails?.id_no : null;
        this.setState({ isDisabled: true })
        try {
            let states = this.state;
            var data = {
                "ip_admission_id": states?.ipPatientData?.id,
                "claim_amount": +states?.TotalClaimAmt,
                "primary_payment_type": this.state?.CreditDetails?.credit_type === "Corporate credit" ? 'Corporate credit' : this.state?.CreditDetails?.credit_type === "Insurance credit" ? 'Insurance credit' : null,
                "policy_company_name": Company_Name,
                "policy_number": ID_No,
                "approved_amount": +states?.ApprovedAmt,
                "disallowance_amount": +states?.DisallowanceAmt,
                "tds_amount": +states?.TDSAmount
            }
            RestAPIService.create(data, Serviceurls.PRE_AUTHORIZATION_POST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            isDisabled: false
                        }, () => { this.getPatientData() })
                        this.successMessage(response.data.message)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderLeftContent = () => {
        const { t } = this.props
        const userAccess = this.props.FromOP ? CheckAccessFunc("front_office", "Home", "Insurance", "Claim Details", "SubTab")?.editAccess :
        CheckAccessFunc("front_office", "In Patients", "Insurance", "Claim Details", "SubTab")?.editAccess;
        return (
            <div>
                <Box component={'div'} className='eMed_IP_Discharge_Header'>
                    <Box>
                        <Typography paddingLeft={"0.5vw"} fontWeight={600}>{t('Claim Amount Details')}</Typography>
                    </Box>
                </Box>
                {this.state?.CreditDetails?.credit_type === "Corporate credit" ?
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}>
                        There was no insurance linked with this patient
                    </div> :
                    (localGetItem('isNewBilling') === "true") ?
                        <div>
                            <Box component={'div'} style={{ padding: "0.5vw", display: "flex", flexDirection: "column", marginLeft: "1.5vw" }}>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1vw" }}>
                                    <div style={{ width: "12vw", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                        <div style={{ fontWeight: 600 }}>Total Bill Amount</div>
                                         {this.props?.FromOP ? null : <div style={{ fontSize: "0.9vw" }}>{"(After Generate Final Bill)"}</div>}
                                    </div>
                                    {this.props?.FromOP ?
                                    <div style={{ marginLeft: "2vw" }}>{`:  ${AmountFormat(this.state?.TotalBillAmt)}`}</div>
                                    : this.state.CreditDetails?.is_final_bill_generated && this.state?.CreditDetails?.policy_status !== "Not Approved" ? <div style={{ marginLeft: "2vw" }}>{`:  ${AmountFormat(this.state?.TotalBillAmt)}`}</div> :
                                        this.state?.CreditDetails?.policy_status === "Not Approved" ? <Typography sx={{ fontSize: "0.8vw", color: Colors.red, fontWeight: 600, ml: "2vw" }}>: Pre Authorization Not Approved</Typography> :
                                            <Typography sx={{ fontSize: "0.8vw", color: Colors.red, fontWeight: 600, ml: "2vw" }}>: Final Bill Not Generated</Typography>}
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1.5vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>Patient Paid Amount</div>
                                    <div style={{ marginLeft: "2vw" }}>{`:  ${AmountFormat(this.state.Patientpaid || 0)}`}</div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1.5vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>Insurance Claim Amount</div>
                                    <div style={{ marginLeft: "2vw" }}>{`:  ${AmountFormat(this.state.InsuClaimAmt || 0)}`}</div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1.5vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>Received Amount</div>
                                    <div style={{ marginLeft: "2vw" }}>{`:  ${AmountFormat(this.state.InsuReceivedAmt)}`}</div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1.5vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>TDS</div>
                                    <div style={{ marginLeft: "2vw" }}>{`:  ${AmountFormat(this.state.TDSAmount)}`}</div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1.5vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>Disallowance</div>
                                    <div style={{ marginLeft: "2vw" }}>{`:  ${AmountFormat(this.state.DisallowanceAmt)}`}</div>
                                </div>
                            </Box>
                        </div>
                        :
                        <div>
                            <Box component={'div'} style={{ padding: "0.5vw", display: "flex", flexDirection: "column", marginLeft: "1.5vw" }}>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1vw" }}>
                                    <div style={{ width: "12vw", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                        <div style={{ fontWeight: 600 }}>Total Bill Amount</div>
                                        {this.props?.FromOP ? null : <div style={{ fontSize: "0.9vw" }}>{"(After Generate Final Bill)"}</div>}
                                    </div>
                                    {this.props?.FromOP ?
                                    <div style={{ marginLeft: "2vw" }}>{`:  ${AmountFormat(this.state?.TotalBillAmt)}`}</div>
                                    : this.state.CreditDetails?.is_final_bill_generated && this.state?.CreditDetails?.policy_status !== "Not Approved" ? <div style={{ marginLeft: "2vw" }}>{`:  ${AmountFormat(this.state?.TotalBillAmt)}`}</div> :
                                        this.state?.CreditDetails?.policy_status === "Not Approved" ? <Typography sx={{ fontSize: "0.8vw", color: Colors.red, fontWeight: 600, ml: "2vw" }}>: Pre Authorization Not Approved</Typography> :
                                            <Typography sx={{ fontSize: "0.8vw", color: Colors.red, fontWeight: 600, ml: "2vw" }}>: Final Bill Not Generated</Typography>}
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1.5vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>Received Amount</div>
                                    <div style={{ marginLeft: "2vw" }}>{`:  ${AmountFormat(this.state.receivedAmt)}`}</div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1.5vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>Approved Amount</div>
                                    <div>
                                        <OutlinedInput
                                            value={this.state.ApprovedAmt ? this.state.ApprovedAmt : ""}
                                            disabled={this.state?.isDisabled || this.state?.CreditDetails?.policy_status === "Not Approved"}
                                            startAdornment={<InputAdornment position="start">{CurrencySymbol}</InputAdornment>}
                                            sx={{ height: "2vw", fontSize: "0.9vw", width: "8.5vw", marginLeft: "2vw" }}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                let isValid = false;
                                                isValid = CommonValidation.NumberWithDot(value);
                                                if ((value === "" || (isValid && value > 0)) && +e.target.value <= +this.state.TotalBillAmt) {
                                                    this.setState({
                                                        ApprovedAmt: e.target.value,
                                                        TotalClaimAmt: e.target.value, DisallowanceAmt: "", TDSAmount: ""
                                                    })
                                                }
                                            }}
                                            emed_tid="claim_details_approved_amount_input" />
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1.5vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>Disallowance Amount</div>
                                    <div>
                                        <OutlinedInput
                                            value={this.state.DisallowanceAmt ? this.state.DisallowanceAmt : ""}
                                            disabled={this.state?.isDisabled && (this.state.ApprovedAmt > 0) || this.state?.CreditDetails?.policy_status === "Not Approved"}
                                            startAdornment={<InputAdornment position="start">{CurrencySymbol}</InputAdornment>}
                                            sx={{ height: "2vw", fontSize: "0.9vw", width: "8.5vw", marginLeft: "2vw" }}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                let isValid = false;
                                                let ClaimAmount = ((+this.state.ApprovedAmt - +this.state.TDSAmount) - +e.target.value)
                                                isValid = CommonValidation.NumberWithDot(value);
                                                if ((value === "" || (isValid && value > 0)) && e.target.value <= +this.state.ApprovedAmt) {
                                                    this.setState({
                                                        DisallowanceAmt: e.target.value,
                                                        TotalClaimAmt: ClaimAmount
                                                    })
                                                }
                                            }}
                                            emed_tid="claim_details_disallowance_amount_input" />
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1.5vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>TDS</div>
                                    <div>
                                        <OutlinedInput
                                            value={this.state.TDSAmount ? this.state.TDSAmount : ""}
                                            disabled={this.state?.isDisabled && (this.state.ApprovedAmt > 0) || this.state?.CreditDetails?.policy_status === "Not Approved"}
                                            startAdornment={<InputAdornment position="start">{CurrencySymbol}</InputAdornment>}
                                            sx={{ height: "2vw", fontSize: "0.9vw", width: "8.5vw", marginLeft: "2vw" }}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                let isValid = false;
                                                let ClaimAmount = ((+this.state.ApprovedAmt - +this.state.DisallowanceAmt) - +e.target.value)
                                                isValid = CommonValidation.NumberWithDot(value);
                                                if ((value === "" || (isValid && value > 0)) && e.target.value <= +this.state.ApprovedAmt) {
                                                    this.setState({
                                                        TDSAmount: e.target.value,
                                                        TotalClaimAmt: ClaimAmount
                                                    })
                                                }
                                            }}
                                            emed_tid="claim_details_tds_amount_input" />
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "1.5vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>Claim Amount</div>
                                    <div>
                                        <OutlinedInput
                                            value={this.state.TotalClaimAmt > 0 ? this.state.TotalClaimAmt : 0}
                                            disabled={true}
                                            startAdornment={<InputAdornment position="start">{CurrencySymbol}</InputAdornment>}
                                            sx={{ height: "2vw", fontSize: "0.9vw", width: "8.5vw", marginLeft: "2vw" }}
                                            onChange={(e) => {
                                                this.setState({
                                                    TotalClaimAmt: e.target.value
                                                })
                                            }} />
                                    </div>
                                </div>
                                {/* <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "2vw" }}>
                                    <div style={{ width: "12vw", fontWeight: 600 }}>Pending Amount</div>
                                    <div style={{ marginLeft: "2vw" }}>{`:  ${(this.state.PendingAmt).toFixed(2)}`}</div>
                                </div> */}
                            </Box>
                            <Stack spacing={2} direction="row" id='eMed_recPayment_rightBtnCon' sx={{ marginTop: "1.5vw", marginRight: "1vw" }} alignItems="center" justifyContent="flex-end">
                                <Button disabled={this.state?.isDisabled || this.state?.CreditDetails?.policy_status === "Not Approved"} variant='outlined' size="small" id="eMed_recPayment_btn" onClick={() => { this.handleClear() }} emed_tid="claim_details_clear_btn">{t("Clear")}</Button>
                                <Button disabled={(this.state.isDisabled || this.state.TotalClaimAmt <= 0) || this.state?.CreditDetails?.policy_status === "Not Approved" || !userAccess} variant='contained' size="small" id="eMed_recPayment_btn" onClick={() => { this.handleSave() }} emed_tid="claim_details_save_btn">{t("Save")}</Button>
                            </Stack>
                        </div>}
            </div>
        )
    }

    render() {
        const { t } = this.props
        var { opPatientData } = this.state
        let attender = {}
        let consultant = {}
        if (this.props?.FromOp) {
            attender = {
                lineOne: t("AttenderName"),
                lineTwo: `${opPatientData?.caretaker_name ? opPatientData?.caretaker_name : '-'}`,
                lineFour: t('ContactNumber'),
                LineFive: `${opPatientData?.caretaker_number ? opPatientData?.caretaker_number : '-'}`
            }
            consultant = {
                lineOne: t("ConsultantName"),
                lineTwo: `${opPatientData?.doctor_name ? opPatientData?.doctor_name : '-'}`,
            }
        } else {
            attender = {
                lineOne: t("AttenderName"),
                lineTwo: `${opPatientData.attender_name ? opPatientData.attender_name : '-'}`,
                lineFour: t('ContactNumber'),
                LineFive: `${opPatientData.attender_mobile ? opPatientData.attender_mobile : '-'}`
            }
            consultant = {
                lineOne: t("ConsultantName"),
                lineTwo: `${opPatientData.doctor_name ? opPatientData.doctor_name : '-'}`,
            }
        }
        return (
            <Box sx={{ backgroundColor: Colors.ComponentBgColor }}>
                <Box component={'div'} marginLeft={'0.5vw'} className='eMed_patient_header'>
                    <Box display={'flex'} alignItems='center'>
                        <Box className='eMed_Patient_Details_Long eMed_patient_box'>
                            <CommonPatientDetails data={this.state.opPatientData} showDetailed={true} />
                        </Box>
                        <CommonPatientCard details={attender} showDetailed={true} />
                        <ConsultantPatientCard name={consultant} />
                    </Box>
                </Box>
                <Box display={'flex'} flexDirection={'row'} marginTop={"0.5vw"}>
                    <Paper elevation={3} className='eMed_DocNotes_Left_Main'>
                        {this.renderLeftContent()}
                    </Paper>
                </Box>
                <Loader loaderOpen={this.state.isLoader} />
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}
export default withTranslation()(ClaimDetails);